import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import bundleinword from '../../src/services/bundle-inward.services';

export const fetchBundleInWardList = createAsyncThunk(
  'bundleinword/fetchBundleInWardList',
  async (
    { page, pagesize, search, id, ordering, start_date, end_date },
    thunkAPI,
  ) => {
    try {
      const response = await bundleinword.getBundleInWard(
        page,
        pagesize,
        search,
        id,
        ordering,
        start_date,
        end_date,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchWorkOrderListInBundleInward = createAsyncThunk(
  'bundleinword/fetchWorkOrderListInBundleInward',
  async ({ page, pagesize, search }, thunkAPI,) => {
    try {
      const response = await bundleinword.getWorkOrderListInBundleInward(
        page,
        pagesize,
        search,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchBundleInWardListByItem = createAsyncThunk(
  'bundleinword/fetchBundleInWardListByItem',
  async ({ page, pagesize, search, id, ordering, workOrderId }, thunkAPI) => {
    try {
      const response = await bundleinword.getBundleInWardByItem(
        page,
        pagesize,
        search,
        id,
        ordering,
        workOrderId,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchBundleInWardByWorkorderItem = createAsyncThunk(
  'bundleinword/fetchBundleInWardByWorkorderItem',
  async ({ page, pagesize, search, id, ordering, selectedId }, thunkAPI) => {
    try {
      const response = await bundleinword.getBundleInWardByWorkorderItemWise(
        page,
        pagesize,
        search,
        id,
        ordering,
        selectedId,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchBundleInWardStatusByItem = createAsyncThunk(
  'bundleinword/fetchBundleInWardStatusByItem',
  async (
    { page, pagesize, search, workOrderId, ordering, selectedId },
    thunkAPI,
  ) => {
    try {
      const response = await bundleinword.getBundleInWardStatusByItem(
        page,
        pagesize,
        search,
        workOrderId,
        ordering,
        selectedId,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchArchivedQuotationList = createAsyncThunk(
  'bundleinword/fetchArchivedQuotationList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await bundleinword.getQuotationArchiveList(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const getWarehouseMovedBundleSummary = createAsyncThunk(
  'bundleinword/getWarehouseMovedBundleSummary',
  async (id, thunkAPI) => {
    try {
     const response =  await bundleinword.getBundleStatusWarehouseSummary(id); // Ensure `id` is used here
      return response.data; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteBundleInwardList = createAsyncThunk(
  'bundleinword/deleteBundleInwardList',
  async (id, thunkAPI) => {
    try {
      await bundleinword.deleteBundleinwardList(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchBundleInWardById = createAsyncThunk(
  'bundleinword/fetchBundleInWardById',
  async ({ id, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await bundleinword.getBundleInWardById(
        id,
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchQuotationById = createAsyncThunk(
  'bundleinword/fetchQuotationById',
  async (dieProfileId, { rejectWithValue }) => {
    try {
      const response = await bundleinword.getQuotationById(dieProfileId);
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const createBundleInWard = createAsyncThunk(
  'bundleinword/createBundleInWard',
  async ({ values }, thunkAPI) => {
    try {
      const response = await bundleinword.addBundleInWard(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const quotationCreateWorkoder = createAsyncThunk(
  'bundleinword/quotationCreateWorkoder',
  async ({ values }, thunkAPI) => {
    try {
      const response = await bundleinword.QuotationByCreateWorkOrder(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const updateQuotation = createAsyncThunk(
  'bundleinword/updateQuotation',
  async ({ id, values }, thunkAPI) => {
    try {
      const response = await bundleinword.updateQuotation(id, values);
      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const shiftBundleExcessStock = createAsyncThunk(
  'bundleinword/shiftBundleExcessStock',
  async ({ values }, thunkAPI) => {
    try {
      const response = await bundleinword.shiftBundleExcessStock(values);
      return response; // Assuming response contains the created die size data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const deleteQuotation = createAsyncThunk(
  'bundleinword/deleteQuotation',
  async (id, thunkAPI) => {
    try {
      await bundleinword.deleteQuotation(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveQuotation = createAsyncThunk(
  'bundleinword/unArchiveQuotation',
  async (id, thunkAPI) => {
    try {
      await bundleinword.unArchiveQuotationRecord(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState = {
  data: [], // List
  list: [],
  workorderlist: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  loading: false,
  hasMore: true,
};

const bundleinwordSlice = createSlice({
  name: 'bundleinword',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetQuotationData: state => {
      state.data = []; // This will clear the list
    },
    resetWorkOrderListInBundleInward: state => {
      state.workorderlist = []; // This will clear the list
      state.totalRecord = 0;
    },
    resetBundleInwardList: state => {
      state.list = []; // This will clear the list
      state.data = [];
      state.totalRecord = 0;
    },
    resetCurrentQuotationPage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBundleInWardList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchBundleInWardList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchBundleInWardList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchWorkOrderListInBundleInward.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchWorkOrderListInBundleInward.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.workorderlist = [...state.workorderlist, ...action.payload.results.data];
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
       
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchWorkOrderListInBundleInward.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder.addCase(fetchBundleInWardListByItem.fulfilled, (state, action) => {
      state.status = 'succeeded';
      const responseData = action.payload?.data || [];

      state.data = responseData; // Store the 'data' array correctly
      state.totalRecord = responseData.length; // Use length since count is missing
      state.totalPages = Math.ceil(responseData.length / state.pageSize); // Calculate total pages
      state.data = responseData;
      state.totalRecord = responseData.length;
      state.totalPages = Math.ceil(responseData.length / state.pageSize); 
      if (responseData.length === 0) {
        state.status = 'no_data';
      }
    });

    builder
      .addCase(fetchArchivedQuotationList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedQuotationList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedQuotationList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchQuotationById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotationById.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchQuotationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createBundleInWard.pending, state => {
        state.status = 'loading';
      })
      .addCase(createBundleInWard.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createBundleInWard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
    builder
      .addCase(updateQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const updateDieProfile = action.payload;
        const index = state.data.findIndex(
          group => group.id === updateDieProfile.id,
        ); // Find the index of the updated group
        if (index !== -1) {
          state.data[index] = updateDieProfile; // Replace the old group with the updated one
        }
      })
      .addCase(updateQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(deleteQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(deleteQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(deleteQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(unArchiveQuotation.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveQuotation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveQuotation.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  resetQuotationData,
  resetBundleInwardList,
  resetWorkOrderListInBundleInward,
  resetCurrentQuotationPage,
} = bundleinwordSlice.actions;
export default bundleinwordSlice.reducer;
